import { CustomIcons, Stack } from '@ltvco/refresh-lib/theme';
import { PillList } from '@ltvco/refresh-lib/v1';
import { FilterTypeOption, type SideMenuItem } from '@ltvco/refresh-lib/v2';
import {
  List,
  FacebookRounded,
  Instagram,
  LinkedIn,
  Pinterest,
  Person,
  Phone,
  Home,
  Email,
  AlternateEmail,
  DirectionsCar,
  Restore,
  Radar,
  Psychology,
  FlareRounded,
  LocalFlorist,
  Redeem,
  PieChartOutline,
  NotificationsNone,
  PersonPinCircle,
  DirectionsCarRounded,
  AttachMoney,
  MapRounded,
  Work,
  AccountCircle,
  PersonAdd,
  Summarize,
  Search,
  Lightbulb,
  FamilyRestroom,
  NotificationsActive,
  ManageAccounts,
  X,
  LocalLibraryRounded,
  Gavel,
  AutoAwesomeRounded,
  Notifications,
  Favorite,
  LocationCity,
  Groups,
  CloudUpload,
} from '@mui/icons-material';

import { BVLogo } from 'icons';
import aquarius from 'images/ast-aquarius.svg';
import aries from 'images/ast-aries.svg';
import cancer from 'images/ast-cancer.svg';
import capricorn from 'images/ast-capricorn.svg';
import compatibilityImg from 'images/ast-compatibility.svg';
import empty from 'images/ast-empty.png';
import gemini from 'images/ast-gemini.svg';
import leo from 'images/ast-leo.svg';
import libra from 'images/ast-libra.svg';
import emptyBackground from 'images/ast-numerology.svg';
import pisces from 'images/ast-pisces.svg';
import sagittarius from 'images/ast-sagittarius.svg';
import scorpio from 'images/ast-scorpio.svg';
import smallAquarius from 'images/ast-small-aquarius.svg';
import smallAries from 'images/ast-small-aries.svg';
import smallAscendant from 'images/ast-small-ascendant.svg';
import smallCancer from 'images/ast-small-cancer.svg';
import smallCapricorn from 'images/ast-small-capricorn.svg';
import smallGemini from 'images/ast-small-gemini.svg';
import smallLeo from 'images/ast-small-leo.svg';
import smallLibra from 'images/ast-small-libra.svg';
import smallPisces from 'images/ast-small-pisces.svg';
import smallSagittarius from 'images/ast-small-sagittarius.svg';
import smallScorpio from 'images/ast-small-scorpio.svg';
import smallTaurus from 'images/ast-small-taurus.svg';
import smallVirgo from 'images/ast-small-virgo.svg';
import taurus from 'images/ast-taurus.svg';
import virgo from 'images/ast-virgo.svg';
import imgBellCurveNull from 'images/bell-curve-null.svg';
import imgBellCurve from 'images/bell-curve.svg';
import bvLogoPng from 'images/bv_logo_png.png';
import imgFamilyAlbumEmpty from 'images/family-album-empty.svg';
import imgFamilyTreeCameraIcon from 'images/family-tree-camera-icon.svg';
import imgFamilyTreeCloudUploadIcon from 'images/family-tree-cloud-upload-icon.svg';
import imgFamilyTreeDeathIndexIcon from 'images/family-tree-death-index-icon.svg';
import imgFamilyTreePhotoPlaceholderIcon from 'images/family-tree-photo-placeholder-icon.svg';
import imgFamilyTreeViewDocument from 'images/family-tree-view-document.svg';
import group2Icon from 'images/group-2.svg';
import IdMonitorBvLogo from 'images/id-monitor-bv-logo.svg';
import imgAccidentsIcon from 'images/img-accidents-icon.svg';
import imgDamagesIcon from 'images/img-damages-icon.svg';
import imgImpoundsIcon from 'images/img-impounds-icon.svg';
import imgLiensIcon from 'images/img-liens-icon.svg';
import imgRepairsIcon from 'images/img-repairs-icon.svg';
import imgSalvagesIcon from 'images/img-salvages-icon.svg';
import imgTitleBrandsIcon from 'images/img-title-brands-icon.svg';
import imgTitleRecordsIcon from 'images/img-title-records-icon.svg';
import imgCreateList from 'images/img_create_list.svg';
import imgFamilySearchAncestor from 'images/img_family_search_ancestor.svg';
import imgMigrationCta from 'images/img_migration_cta.svg';
import imgNameHistorySearch from 'images/img_name_history_search.png';
import imgUnclaimedMoneyBannerLogo from 'images/img_unclaimed_money_banner_logo.png';
import imgCreateFamilyMemberIcon from 'images/imgMemberCreator.svg';
import imgNotificationBanner from 'images/notifications-banner.png';
import reactivationFireIcon from 'images/reactivation-fire-icon.svg';
import reactivationLock from 'images/reactivation-lock.svg';
import reactivationMembershipIcon from 'images/reactivation-membership-icon.svg';
import reactivationSwitchPlanIcon from 'images/reactivation-switch-plan-icon.svg';
import imgVerticalArrowNull from 'images/vertical-arrow-null.svg';
import imgVerticalArrow from 'images/vertical-arrow.svg';

import personalityTraitsLoading from './animations/personality-traits-loading.json';
import imgAddVehicle from './images/add-vehicle.svg';
import imgAiFamilyPhotosBannerIcon from './images/ai-family-photos-banner-icon.svg';
import imgAncestorReportFamilyIcon from './images/ancestor-report-family.svg';
import imgAnimatedPersonMagnifying from './images/ani_person_magnifying.gif';
import imgAstrologyStandAloneOnboarding from './images/ast-standalone-onboarding-bg.svg';
import AstrologyIcon from './images/astrology-icon.svg';
import imgToggleToSatellite from './images/btn-map-satellite.png';
import imgToggleToStreet from './images/btn-map-street.png';
import bvMobileBannerIcon from './images/bv-mobile-banner-icon.svg';
import imgCakeRounded from './images/cake-rounded.svg';
import imgCampaign from './images/campaign.svg';
import cancelDownsellBackgroundMobile from './images/cancel-downsell-bg-mobile.svg';
import cancelDownsellBackground from './images/cancel-downsell-bg.svg';
import imgChristmasClaymationFullFamilyPhoto from './images/christmas_full.png';
import downsellModalBackground from './images/Circle-gradient-bg.svg';
import imgClock from './images/clock.svg';
import imgColonialTimes from './images/colonial-times.png';
import imgColonialTimesFullFamilyPhoto from './images/colonial_full.png';
import colorBar from './images/color-bar.svg';
import imgColorizeYourPhoto from './images/colorize-your-photo.png';
import imgContactSearchRightArrow from './images/contact-search-right-arrow.svg';
import imgCurrentOwner from './images/current-owner-icon.svg';
import imgDefaultContactSearchMessage from './images/default-contact-search-message.svg';
import DigitalIdentityLogo from './images/digital-id-logo.svg';
import imgDollar from './images/dollar.svg';
import downSellCancelModalIcon from './images/downsell-cancel-modal-icon.svg';
import downsellSpecialOfferImg from './images/downsellSpecialOffer.svg';
import earthquakeIcon from './images/earthquake.svg';
import imgEmission from './images/emission.svg';
import errorComputer from './images/error-computer.svg';
import imgFamilySearchIcon from './images/family-search-icon.svg';
import imgFamilySearchTreeIcon from './images/family-search-tree-icon.svg';
import imgFamilySearch from './images/family-search.svg';
import imgFamilyTreeAddRelative from './images/family-tree-add-relative.svg';
import imgFamilyTreeAILogo from './images/family-tree-ai-logo.svg';
import imgFamilyTreeBackground from './images/family-tree-background.svg';
import imgFamilyTreeDeceased from './images/family-tree-deceased.svg';
import imgFamilyTreeMainDetails from './images/family-tree-main-details-img.svg';
import imgFamilyTreeNames from './images/family-tree-names-img.svg';
import imgFamilyTreeOriginalMember from './images/family-tree-original-member.svg';
import imgFamilyTreePetIcon from './images/family-tree-pet-icon.svg';
import imgFamilyTreePlaceholder from './images/family-tree-placeholder.svg';
import imgFamilyTreeSearch from './images/family-tree-search-img.svg';
import imgFamilyTreeStarsIcon from './images/family-tree-stars-icon.svg';
import imgFamilyTreeBuilderBlue from './images/family-tree-tree-builder-blue.svg';
import imgFamilyTreeBuilder from './images/family-tree-tree-builder.svg';
import imgFamilyTree from './images/family-tree-tree-img.svg';
import imgFlowerObituary from './images/flowerObituary.svg';
import fourMainPersonalityTypesMobile from './images/four-main-personality-types-mobile.svg';
import fourMainPersonalityTypes from './images/four-main-personality-types.svg';
import imgHalloweenFullFamilyPhoto from './images/halloween_full.png';
import imgCheckList from './images/icn_img_checklist.svg';
import imgIdHub from './images/id-hub.svg';
import imgAiFamilyPhotosDashboardBanner from './images/img-ai-photos-banner.svg';
import ComplianceLogo from './images/img-alert.svg';
import imgAppleStore from './images/img-appstore.svg';
import imgCheckIcon from './images/img-check-icon.svg';
import imgChristmasClaymation from './images/img-christmas-claymation-ai-photo.png';
import imgCloseIcon from './images/img-close-icon.svg';
import imgCrestAIPhotoBannerFullWidth from './images/img-crest-ai-photo-banner-full-width.png';
import imgCrestAIPhotoBanner from './images/img-crest-ai-photo-banner.png';
import imgCrestAIPhoto from './images/img-crest-ai-photo.png';
import imgCrimeFeedCTA from './images/img-crime-feed-cta.svg';
import imgDarkWebEmail from './images/img-dark-web-email.svg';
import personalityTraitsModalDots from './images/img-dots.svg';
import imgEmailSearchGraphic from './images/img-email-search.svg';
import imgGoogleStore from './images/img-google-play.svg';
import imgHalloween from './images/img-halloween-ai-photo.svg';
import imgPremiumFrame from './images/img-premium-frame.svg';
import imgPremiumSearchIcon from './images/img-premium-search-icon.svg';
import personalityTraitsModal from './images/img-pt-modal-header.png';
import imgRadialCar from './images/img-radial-car.svg';
import imgRadialProperty from './images/img-radial-property.svg';
import searchpal from './images/img-searchpal.svg';
import imgThanksgivingParade from './images/img-thanksgiving-ai-photo.svg';
import img24hr from './images/img_24hr.svg';
import imgAddressGeneric from './images/img_address_generic_no_bg.svg';
import imgAmenities from './images/img_amenities.svg';
import american_express from './images/img_amex.svg';
import imgAppStoreBadge from './images/img_apple_app_store_badge.svg';
import applePay from './images/img_apple_pay.svg';
import imgAreaPin from './images/img_areapin.svg';
import imgAstrologyNumerology from './images/img_astrology_numerology.svg';
import imgAstrologyNumerologyLoading from './images/img_astrology_numerology_loading.svg';
import imgAstrologyNumerologyV2 from './images/img_astrology_numerology_v2.svg';
import imgAttachmentJpg from './images/img_attachment_jpg.svg';
import imgAttachmentPdf from './images/img_attachment_pdf.svg';
import imgGooglePlayBadge from './images/img_badge_google_play.svg';
import imgBell from './images/img_bell.svg';
import imgMonitoringBell from './images/img_bell_monitoring.svg';
import imgBrazilFlag from './images/img_brazil_flag.svg';
import imgCircleUser from './images/img_circle_user.svg';
import imgCloudDocumentLockBox from './images/img_cloud_document_lockbox.svg';
import imgComputerLimitReached from './images/img_computer_limit_reached.svg';
import imgContactlessIcon from './images/img_contactless_icon.svg';
import imgCopyIcon from './images/img_copy_icon.svg';
import imgCustomerService from './images/img_customer_service.svg';
import imgDarkWebScan from './images/img_dark_web_scan.svg';
import imgDashBell from './images/img_dash_bell.svg';
import imgDashFraud from './images/img_dash_fraud.svg';
import imgDashHacker from './images/img_dash_hacker.svg';
import imgDashId from './images/img_dash_id.svg';
import imgDashMoney from './images/img_dash_money.svg';
import imgDashPrize from './images/img_dash_prize.svg';
import imgDashUser from './images/img_dash_user.svg';
import discover from './images/img_discover.svg';
import imgEllipsePin from './images/img_ellipse_pin.svg';
import imgEtagsLogo from './images/img_etags_logo.svg';
import imgExampleAircraft from './images/img_example_aircraft.svg';
import imgExampleAutomobile from './images/img_example_automobile.svg';
import imgExampleWatercraft from './images/img_example_watercraft.svg';
import imgExpiredEmailLink from './images/img_expired_email_link.svg';
import imgFallbackProperty from './images/img_fallback_property.svg';
import imgFraudCheck from './images/img_fraud_check.svg';
import genericCreditCard from './images/img_generic_credit_card.svg';
import imgGlobalDocumentLockBox from './images/img_global_attachment.svg';
import googlePay from './images/img_google_pay.svg';
import imgInfinity from './images/img_infinity.svg';
import imgMagnifyingGlassNoResultsPage from './images/img_magnifying_glass_no_results.svg';
import imgMailBox from './images/img_mailbox.svg';
import imgMapDefaultPin from './images/img_map_default_pin.png';
import imgMapMainHomePin from './images/img_map_main_home_pin.svg';
import imgMapPinBlue from './images/img_map_pin_blue.svg';
import imgMapSecondaryPin from './images/img_map_secondary_pin.svg';
import imgMarketTrends from './images/img_market_trends.svg';
import masterCard from './images/img_mastercard.svg';
import imgMobileExpIcon from './images/img_mobile_exp_icon.svg';
import imgMobileFreemium from './images/img_mobile_freemium.svg';
import imgMyAccountVin from './images/img_myaccount_vin.svg';
import imgMyGarageBrake from './images/img_mygarage_brake.svg';
import imgMyGarageOilChange from './images/img_mygarage_oilchange.svg';
import imgMyGarageSellYourCar from './images/img_mygarage_sellyourcar.svg';
import imgMyGarageStar from './images/img_mygarage_starfilled.svg';
import imgMyGarageTireChange from './images/img_mygarage_tirechange.svg';
import imgMyGarageTitleCheck from './images/img_mygarage_titlecheck.svg';
import imgNHFacts from './images/img_neighborhood_facts.svg';
import imgMonitorBanner from './images/img_neighborhood_safety.svg';
import imgNMVTISLogo from './images/img_nmvtis_logo.svg';
import imgNoticeLeave from './images/img_notice_leave.svg';
import paymentRequired from './images/img_payment_required.svg';
import paymentRequiredV2 from './images/img_payment_required_v2.svg';
import paypal from './images/img_paypal.svg';
import img_pdf_glow from './images/img_pdf_glow.svg';
import imgPersonSearch from './images/img_person_search.svg';
import imgMapBoxPin from './images/img_pin.svg';
import imgPlaceholderSexOffender from './images/img_placeholder_sex_offender.svg';
import imgPremiumBadge from './images/img_premium_badge.svg';
import imgReferralsIcon from './images/img_referrals_icon.svg';
import imgReportRating from './images/img_report_rating.svg';
import imgSaveListProperty from './images/img_save_list_property.svg';
import imgSingleTree from './images/img_single_tree.svg';
import beenverifiedLogo from './images/img_social_beenverified.svg';
import facebookLogo from './images/img_social_facebook.svg';
import instagramLogo from './images/img_social_instagram.svg';
import linkedinLogo from './images/img_social_linkedin.svg';
import pinterestLogo from './images/img_social_pinterest.svg';
import twitterLogo from './images/img_social_twitter.svg';
import imgSpainFlag from './images/img_spain_flag.svg';
import imgSingleSignOnCta from './images/img_sso_cta.svg';
import imgSuccessfulUpgrade from './images/img_successful_upgrade.svg';
import imgTitleChecks from './images/img_title_checks.svg';
import imgTitleRegistration from './images/img_title_registration.svg';
import imgTreeOfLife from './images/img_tree_of_life.svg';
import imgUpdatesIcon from './images/img_updates_icon.svg';
import imgUploadAttachmentIcon from './images/img_upload_attachment_icon.svg';
import imgUSflag from './images/img_usa_flag.svg';
import venmo from './images/img_venmo.svg';
import venmoButton from './images/img_venmo_button.svg';
import visa from './images/img_visa.svg';
import imgWhatIsAVin from './images/img_what_is_a_vin.svg';
import imgWhatIsAVinV2 from './images/img_what_is_a_vin_v2.svg';
import imgWhereIsVin from './images/img_where_is_vin.svg';
import imgWhereIsVinV2 from './images/img_where_is_vin_v2.svg';
import Bankrupticies from './images/imgBankruptcies.svg';
import ClaimedReport from './images/imgClaimedReport.svg';
import ClaimReport from './images/imgClaimReport.svg';
import Criminal from './images/imgCriminal.svg';
import imgDarkWebSection from './images/imgDarkWebSection.svg';
import MonitoringBell from './images/imgMonitoringBell.svg';
import imgObituarySearchGraphic from './images/imgObituarySearchGraphic.svg';
import imgPoweredByGoogleTranslate from './images/imgPoweredGoogleTranslate.svg';
import Traffic from './images/imgTraffic.svg';
import landslideIcon from './images/landslide.svg';
import logoSmall from './images/logo-small.svg';
import logo from './images/logo.svg';
import imgFamilyTreeMapBackground from './images/map-background.svg';
import imgFamilyTreeMapDeceseased from './images/map-deceased.svg';
import imgFamilyTreeMapPinMarker from './images/map-pin-marker.svg';
import imgFamilyTreeMapPin from './images/map-pin.svg';
import imgMountRushmoreFamilyPhoto from './images/mount-rushmore-family-photo.png';
import myGarageCtaImage from './images/my_garage_cta_image.svg';
import neighborSpoofing from './images/neighbor-spoofing.svg';
import imgNeighborhoodBgSearch1 from './images/neighborhood-bg-search-1.svg';
import imgNeighborhoodBgSearch2 from './images/neighborhood-bg-search-2.svg';
import imgDataCollectionsEmptyCard from './images/no-collections.svg';
import imgNoContactResultsFound from './images/no-contact-results-found.svg';
import imgImmediateFamilyEmptyCard from './images/no-immediate-family.svg';
import imgLifeEventEmptyCard from './images/no-life-events.svg';
import imgNoProperty from './images/no-property-img-fallback.svg';
import imgNoRelativesListed from './images/no-relatives-listed.svg';
import imgNoVehicleImageProvided from './images/no-vehicle-image-provided.svg';
import ownerSearchGenericCta from './images/owner-search-generic-cta.svg';
import personalityColorBanner from './images/personality-color-banner.svg';
import personalityColorBar from './images/personality-color-bar.svg';
import personalityTraitType from './images/personality-trait-type.svg';
import agreeableness from './images/personality-traits-agreeableness.svg';
import analyst from './images/personality-traits-analyst.svg';
import compliance from './images/personality-traits-compliance.svg';
import conscientiousness from './images/personality-traits-conscientiousness.svg';
import diplomats from './images/personality-traits-diplomat.svg';
import dominance from './images/personality-traits-dominance.svg';
import explorers from './images/personality-traits-explorer.svg';
import extraversion from './images/personality-traits-extraversion.svg';
import influence from './images/personality-traits-influence.svg';
import personalityTraitsLogo from './images/personality-traits-logo.svg';
import neuroticism from './images/personality-traits-neuroticism.svg';
import openness from './images/personality-traits-openness.svg';
import sentinels from './images/personality-traits-sentinel.svg';
import stability from './images/personality-traits-stability.svg';
import imgPetCreator from './images/pet-creator.svg';
import premiumModalBannerMob1 from './images/premiumModal-banner-mob1.svg';
import premiumModalBannerMob2 from './images/premiumModal-banner-mob2.svg';
import premiumModalBanner from './images/premiumModal-banner.svg';
import premiumModalCrown from './images/premiumModal-crown.svg';
import premiumModalPersonIcon from './images/premiumModal-person.svg';
import premiumModalPhoneIcon from './images/premiumModal-phone.svg';
import premiumModalPropertyIcon from './images/premiumModal-property.svg';
import imgRelativesQuickAdd from './images/relatives_quick_add.svg';
import imgRelativesSearch from './images/relatives_search.svg';
import RewardsBannerBg from './images/rewards-banner-bg.png';
import RewardsBanner from './images/rewards-banner.svg';
import RewardsLogo from './images/rewards-logo.svg';
import rewardsBannerDesktop from './images/rewards_banner_desktop.png';
import rewardsBannerMobile from './images/rewards_banner_mobile.png';
import rewardsCtaImage from './images/rewards_cta_image.svg';
import imgRocket from './images/rocket.svg';
import imgMountRushmoreFullFamilyPhoto from './images/rushmore_full.png';
import imgSafety from './images/safety.svg';
import searchIcon from './images/search-icon.svg';
import SearchLogo from './images/search-logo.svg';
import imgSeverityCritical from './images/severity-critical.svg';
import imgSeverityHigh from './images/severity-high.svg';
import imgSeverityLow from './images/severity-low.svg';
import imgSeverityMedium from './images/severity-medium.svg';
import imgSeverityNone from './images/severity-none.svg';
import imgSpecializedBackgroundCheck from './images/specialized-background-check.svg';
import imgSpecializedUnclaimedMoney from './images/specialized-unclaimed-money.svg';
import timPhoto from './images/sponsored-agent-photo-tim.png';
import yingPhoto from './images/sponsored-agent-photo-ying.png';
import generalPhoto from './images/sponsored-agent-photo.png';
import staypalOnline from './images/staypal-online.svg';
import staypal from './images/staypal.svg';
import imgThanksgivingFullFamilyPhoto from './images/thanksgiving_full.png';
import imgTimelessFamilyPhoto from './images/timeless-family-photo.png';
import trustPilotIcon from './images/trustpilot.svg';
import upgradeLimit from './images/upgrade-limit.svg';
import verificationEmail from './images/verification-email.svg';
import wildfireIcon from './images/wildfire.svg';
import {
  internationalPhoneFraudSearchLocale,
  internationalPhoneSearchLocale,
} from './internationalPhoneInputConfig';

const baseUrl = `${window.location.protocol}//${window.location.host}`;
const reportTypeFilterOptions: { [key: string]: FilterTypeOption } = {
  detailed_person_report: {
    id: 'detailed_person_report',
    display: 'Person',
    eventLabel: 'Person',
  },
  reverse_phone_report: {
    id: 'reverse_phone_report',
    display: 'Phone',
    eventLabel: 'Phone',
  },
  property_report: {
    id: 'property_report',
    display: 'Property',
    eventLabel: 'Property',
  },
  vehicle_report: {
    id: 'vehicle_report',
    display: 'Vehicle',
    eventLabel: 'Vehicle',
  },
  social_network_report: {
    id: 'social_network_report',
    display: 'Email',
    eventLabel: 'Email',
  },
  username_report: {
    id: 'username_report',
    display: 'Username',
    eventLabel: 'Username',
  },
  sex_offender_report: {
    id: 'sex_offender_report',
    display: 'Neighborhood',
    eventLabel: 'Neighborhood',
  },
  obituary_report: {
    id: 'obituary_report',
    display: 'Obituary',
    eventLabel: 'Obituary',
  },
  ancestry_report: {
    id: 'ancestry_report',
    display: 'Ancestor',
    eventLabel: 'Ancestor',
  },
  unclaimed_money_report: {
    id: 'unclaimed_money_report',
    display: 'Unclaimed Money',
    eventLabel: 'Unclaimed Money',
  },
  contact_report: {
    id: 'contact_report',
    display: 'Contact Pro',
    eventLabel: 'Contact',
  },
  phone_fraud_report: {
    id: 'phone_fraud_report',
    display: 'Phone Fraud',
    eventLabel: 'Phone Fraud',
  },
  email_fraud_report: {
    id: 'email_fraud_report',
    display: 'Email Fraud',
    eventLabel: 'Email Fraud',
  },
  ip_fraud_report: {
    id: 'ip_fraud_report',
    display: 'IP Fraud',
    eventLabel: 'IP Fraud',
  },
  url_fraud_report: {
    id: 'url_fraud_report',
    display: 'URL Fraud',
    eventLabel: 'Url Fraud',
  },
  fam_death_index_report: {
    id: 'fam_death_index_report',
    display: 'Death Index',
    eventLabel: 'Death Index',
  },
  fam_census_report: {
    id: 'fam_census_report',
    display: 'Census',
    eventLabel: 'Census',
  },
  fam_marriage_index_report: {
    id: 'fam_marriage_index_report',
    display: 'Marriage Index',
    eventLabel: 'Marriage Index',
  },
  fam_birth_index_report: {
    id: 'fam_birth_index_report',
    display: 'Birth Index',
    eventLabel: 'Birth Index',
  },
};

// TODO: should we extend the default config the same way we're doing with the theme? might be good for some props, other props maybe should be required
export const constants = {
  images: {
    imgClaimReport: ClaimReport,
    imgDarkWebSection,
    imgClaimedReport: ClaimedReport,
    imgMonitoring: MonitoringBell,
    brandLogo: logo,
    brandLogoMobile: logoSmall,
    imgRewardsLogo: RewardsLogo,
    imgRewardsBanner: RewardsBanner,
    imgRewardsBannerBg: RewardsBannerBg,
    imgDigitalIdentityLogo: DigitalIdentityLogo,
    imgAppleStore,
    imgGoogleStore,
    master: masterCard,
    visa,
    american_express,
    discover,
    genericCreditCard,
    paypal,
    googlePay,
    paymentRequired,
    paymentRequiredV2,
    applePay,
    venmo,
    venmoButton,
    searchLogo: SearchLogo,
    complianceLogo: ComplianceLogo,
    imgDarkWebEmail,
    imgNoProperty,
    imgExampleAircraft,
    imgExampleWatercraft,
    imgExampleAutomobile,
    monitoringBell: imgMonitoringBell,
    imgIdHub,
    imgAddressGeneric,
    imgBell,
    imgDarkWebScan,
    imgSpecializedBackgroundCheck,
    imgSpecializedUnclaimedMoney,
    imgReportRating,
    imgSuccessfulUpgrade,
    imgComputerLimitReached,
    pdfLogo: img_pdf_glow,
    img24hr,
    neighborSpoofing,
    imgAnimatedPersonMagnifying,
    imgMagnifyingGlassNoResultsPage,
    imgMapDefaultPin,
    imgMapMainHomePin,
    imgMapSecondaryPin,
    imgMapPinBlue,
    imgMonitorBanner,
    imgMobileExpIcon,
    imgCopyIcon,
    imgContactlessIcon,
    imgUpdatesIcon,
    imgEtagsLogo,
    imgAddVehicle,
    imgNHFacts,
    imgMarketTrends,
    imgAmenities,
    imgWhereIsVin,
    imgMyAccountVin,
    imgWhereIsVinV2,
    imgWhatIsAVin,
    imgWhatIsAVinV2,
    imgCheckList,
    imgAppStoreBadge,
    imgGooglePlayBadge,
    imgMobileFreemium,
    imgFraudCheck,
    downSellCancelModalIcon,
    bvMobileBannerIcon,
    ownershipHistoryImages: {
      imgCircleUser,
    },
    recallImages: {
      imgSeverityCritical,
      imgSeverityHigh,
      imgSeverityLow,
      imgSeverityMedium,
      imgSeverityNone,
      imgClock,
      imgDollar,
      imgEmission,
      imgSafety,
      imgCampaign,
    },
    imgPremiumBadge,
    imgTitleRegistration,
    imgTitleChecks,
    accidentsCoverageMapImage:
      'https://bv-content.beenverified.com/fit-in/980x0/filters:format(png)/filters:quality(60)/accident_coverage_map.png',
    rewardsBannerMobile,
    rewardsBannerDesktop,
    myGarageCtaImage,
    rewardsCtaImage,
    imgFallbackSexOffender: imgPlaceholderSexOffender,
    verificationEmail,
    imgMapBoxPin,
    imgAreaPin,
    imgMailBox,
    imgReferralsIcon,
    imgCustomerService,
    imgExpiredEmailLink,
    imgFallbackProperty,
    imgPlaceholderSexOffender,
    imgNoVehicleImageProvided,
    imgDashMoney,
    imgDashBell,
    imgDashHacker,
    imgDashId,
    imgDashPrize,
    imgDashUser,
    imgDashFraud,
    imgNoticeLeave,
    imgMyGarage: {
      imgMyGarageBrake,
      imgMyGarageOilChange,
      imgMyGarageSellYourCar,
      imgMyGarageStar,
      imgMyGarageTireChange,
      imgMyGarageTitleCheck,
    },
    nmvtisLogo: imgNMVTISLogo,
    imgToggleToSatellite,
    imgToggleToStreet,
    imgPerksBanner: rewardsBannerDesktop,
    imgPerksBannerMob: rewardsBannerMobile,
    imgRadialCar,
    imgDefaultContactSearchMessage,
    imgNoContactResultsFound,
    imgContactSearchRightArrow,
    imgSaveListProperty,
    imgPremiumData: {
      imgPremiumFrame,
      imgPremiumSearchIcon,
      imgCheckIcon,
      imgCloseIcon,
    },
    imgFlowerObituary,
    imgCakeRounded,
    imgEmailSearchGraphic,
    familyTreeImages: {
      imgRelativesQuickAdd,
      imgPetCreator,
      imgRelativesSearch,
      imgFamilyTreeBackground,
      imgFamilyTreePlaceholder,
      imgFamilyTreeAddRelative,
      imgFamilyTreeDeceased,
      imgFamilyTreePetIcon,
      imgFamilyTreeOriginalMember,
      imgFamilyTreeMapBackground,
      imgFamilyTreeMapPin,
      imgFamilyTreeMapDeceseased,
      imgFamilyTreeSearch,
      imgFamilyTree,
      imgFamilyTreeNames,
      imgFamilyTreeMainDetails,
      imgFamilyTreeMapPinMarker,
      imgFamilySearchIcon,
      imgFamilySearchTreeIcon,
      imgFamilyTreeBuilder,
      imgFamilyTreeBuilderBlue,
      imgFamilyTreeAILogo,
      imgFamilyTreeStarsIcon,
      imgFamilySearch,
      imgFamilyTreeCameraIcon,
      imgFamilyTreeCloudUploadIcon,
      imgFamilyTreePhotoPlaceholderIcon,
      imgFamilyAlbumEmpty,
      brandLogoPng: bvLogoPng,
      imgFamilyTreeViewDocument,
      imgCreateFamilyMemberIcon,
      imgFamilyTreeDeathIndexIcon,
      imgAiFamilyPhotosBannerIcon,
      imgTimelessFamilyPhoto,
      imgMountRushmoreFamilyPhoto,
      imgMountRushmoreFullFamilyPhoto,
      imgChristmasClaymationFullFamilyPhoto,
      imgHalloweenFullFamilyPhoto,
      imgThanksgivingFullFamilyPhoto,
      imgColorizeYourPhoto,
      imgColonialTimes,
      imgColonialTimesFullFamilyPhoto,
      imgHalloween,
      imgThanksgivingParade,
      imgChristmasClaymation,
      imgNoRelativesListed,
      imgAiFamilyPhotosDashboardBanner,
      imgCrestAIPhoto,
      imgCrestAIPhotoBanner,
      imgCrestAIPhotoBannerFullWidth,
      imgLifeEventEmptyCard,
      imgDataCollectionsEmptyCard,
      imgImmediateFamilyEmptyCard,
    },
    ancestor: {
      imgAncestorReportFamilyIcon,
    },
    imgTreeOfLife,
    imgSingleTree,
    imgInfinity,
    imgPersonSearch,
    imgRadialProperty,
    astrology: {
      imgAstrologyNumerology,
      imgAstrologyNumerologyV2,
      imgAstrologyNumerologyLoading,
      compatibilityImg,
      aries,
      taurus,
      gemini,
      cancer,
      leo,
      virgo,
      libra,
      scorpio,
      sagittarius,
      capricorn,
      aquarius,
      pisces,
      empty,
      emptyBackground,
      smallAries,
      smallTaurus,
      smallGemini,
      smallCancer,
      smallLeo,
      smallVirgo,
      smallLibra,
      smallScorpio,
      smallSagittarius,
      smallCapricorn,
      smallAquarius,
      smallPisces,
      smallAscendant,
    },
    astrologyStandalone: {
      imgOnboardingBg: imgAstrologyStandAloneOnboarding,
      AstrologyIcon,
    },
    imgRocket,
    premiumModalCrown,
    premiumModalBanner,
    premiumModalBannerMob1,
    premiumModalBannerMob2,
    premiumModalPersonIcon,
    premiumModalPhoneIcon,
    premiumModalPropertyIcon,
    downsellModalBackground,
    downsellSpecialOfferImg,
    fourMainPersonalityTypes,
    fourMainPersonalityTypesMobile,
    personalityColorBanner,
    personalityColorBar,
    colorBar,
    personalityTraitsLogo,
    errorComputer,
    personalityTraitsModal,
    personalityTraitType,
    personalityTraitsModalDots,
    personalityTraits: {
      analyst,
      diplomats,
      explorers,
      sentinels,
      agreeableness,
      conscientiousness,
      extraversion,
      neuroticism,
      openness,
      stability,
      compliance,
      dominance,
      influence,
    },
    sponsoredAgentPhoto: {
      timPhoto,
      yingPhoto,
      generalPhoto,
    },
    imgSingleSignOnCta,
    ownerSearchGenericCta,
    cancelDownsellBackground,
    cancelDownsellBackgroundMobile,
    trustPilotIcon,
    CourtRecordsImages: {
      imgCriminal: Criminal,
      imgTraffic: Traffic,
      imgBankruptcies: Bankrupticies,
    },
    searchpal,
    staypal,
    staypalOnline,
    imgBellCurve,
    imgBellCurveNull,
    imgVerticalArrow,
    imgVerticalArrowNull,
    imgMigrationCta,
    imgUnclaimedMoneyBannerLogo,
    imgNotificationBanner,
    imgFamilySearchAncestor,
    group2Icon,
    reactivationRedesignImages: {
      reactivationFireIcon,
      reactivationMembershipIcon,
      reactivationSwitchPlanIcon,
      reactivationLock,
    },
    imgCreateList,
    damageHistoryIcons: {
      imgAccidentsIcon,
      imgDamagesIcon,
      imgSalvagesIcon,
      imgRepairsIcon,
    },
    titleHistoryIcons: {
      imgTitleBrandsIcon,
      imgTitleRecordsIcon,
      imgLiensIcon,
      imgImpoundsIcon,
    },
    imgNameHistorySearch,
    searchIcon,
    imgCurrentOwner,
    earthquakeIcon,
    wildfireIcon,
    landslideIcon,
    imgObituarySearchGraphic,
    imgCrimeFeedCTA,
    imgEllipsePin,
    imgCloudDocumentLockBox,
    imgGlobalDocumentLockBox,
    imgUploadAttachmentIcon,
    imgAttachmentJpg,
    imgAttachmentPdf,
    translationFlags: {
      imgSpainFlag,
      imgUSflag,
      imgBrazilFlag,
    },
    imgPoweredByGoogleTranslate,
    upgradeLimit,
    neighborhoodReport: {
      imgNeighborhoodBgSearch1,
      imgNeighborhoodBgSearch2,
    },
  },
  animations: {
    personalityTraitsLoading,
  },
  links: {
    appsFlyerLink: 'https://beenverified.onelink.me/5mdJ/us28hbjx',
    baseUrl: `${baseUrl}${
      import.meta.env.VITE_PATH_PREFIX?.includes('/')
        ? import.meta.env.VITE_PATH_PREFIX
        : `/${import.meta.env.VITE_PATH_PREFIX}`
    }`,
    joinLink: 'https://www.beenverified.com/lp/32fc4f/4/subscribe',
    brandLink: import.meta.env.VITE_DEV_PROXY_SEARCH_PERSON_TEASER
      ? ''
      : `${baseUrl}`,
    aboutLink: 'https://beenverified.com/about',
    fcraLink: 'https://www.beenverified.com/about/fcra/',
    doDontsLink: 'https://www.beenverified.com/about/dos-donts/',
    tosLink: 'https://www.beenverified.com/faq/terms-conditions/',
    privacyLink: 'https://www.beenverified.com/faq/privacy/',
    contactLink: 'https://www.beenverified.com/contact/',
    FaqLink: 'https://beenverified.com/faq/',
    dontSellInfoLink: 'https://www.beenverified.com/svc/optout/search/optouts',
    affiliateLink: 'https://www.beenverified.com/affiliates',
    peopleSearchLink: 'https://www.beenverified.com/people/',
    reversePhoneLink: 'https://www.beenverified.com/reverse-phone/',
    emailLookupLink: 'https://www.beenverified.com/email-search/',
    reverseAddressLink: 'https://www.beenverified.com/reverse-address-lookup/',
    contactForm: 'https://www.beenverified.com/contact/',
    supportLink: 'http://support.beenverified.com/',
    twitterLink: '',
    facebookLink: '',
    blogLink: '',
    brandIosUrl:
      'https://apps.apple.com/us/app/beenverified-background-check/id342585873?utm_source=beenverified&utm_medium=internal&utm_campaign=',
    brandAndroidUrl:
      'https://play.google.com/store/apps/details?id=com.beenverified.android&hl=en_US&utm_source=beenverified&utm_medium=internal&utm_campaign=',
    rapidsLookupLink: '/rpds/lookup',
    etagsPartnerUrl: 'https://www.etags.com/app/us?utm_source=bv',
    mrRogersBaseUrl: '/ss/mrg',
    billingLink: 'https://www.beenverified.com/faq/billing/',
    customPlanLink:
      'https://docs.google.com/forms/d/e/1FAIpQLSdsuNU5p7oD3CX3VvEMrBP1kvG3AodnhSvDytnb36rDVpcpxg/viewform',
    mapboxStyleUrl: 'mapbox://styles/beenverified/cloywa73e00sd01qnb8162waw',
    dataDeckRootURI: 'hk/dd/v2',
    marketplaceBaseUrl: 'https://www.bumper.com/marketplace/',
    accidentDisclaimerURL:
      'https://support.beenverified.com/hc/en-us/articles/16578808406811',
    chatLink: 'https://www.beenverified.com/chat/',
    vehicleReportInquiryURL:
      'https://www.beenverified.com/contact/vehicle-history-report-inquiry/',

    nmvtisGlossaryURL: 'https://vehiclehistory.bja.ojp.gov/nmvtis_glossary',
    nmvtisStatesURL: 'https://vehiclehistory.bja.ojp.gov/nmvtis_states',
    nmvtisDataProvidersURL:
      'https://vehiclehistory.bja.ojp.gov/nmvtis_vehiclehistory',
    nmvtisVehicleHistoryURL: 'http://vehiclehistory.bja.ojp.gov/',
    topHapBaseUrl: 'https://widgets.tophap.com/api/widgets',
    monocleLeadsEndpoint: 'https://www.beenverified.com/mcl/v1/leads',
    cancelSurveyLink:
      'https://docs.google.com/forms/d/e/1FAIpQLSc7YnY1xB6fOht_hHjVb4jSk2Wh5JpdM7ywEAgdZrkm2ubt8Q/viewform',
    propertySummaryFeedbackLink:
      'https://docs.google.com/forms/d/e/1FAIpQLScb1X-yqATHYt4_tGltJiziEKmhsk8UmIEW0EDsEyPRwvcoxQ/viewform',
    propertySmartInsightsSurvey: 'https://forms.gle/RyJoGSwCL3xqpr2v6',
    propertyAdvertiseLink: 'https://forms.gle/iBPaZhfMGbSwZpfR9',
    setupSsoLink: 'https://www.beenverified.com/sso_connections',
    neighborhoodInsightsFeedbackLink:
      'https://docs.google.com/forms/d/1941a6A_AhHAczkO9IH1wVn-w2GvaWgjSd2f5Z8f0b74',
    getMostOutRewardsLink: '/dashboard/rewards?tab=rewards',
    fullAddressFormLink:
      'https://docs.google.com/forms/d/e/1FAIpQLSe1Fg_S_hjb6DA_IY3fmZcFnew1vtS2l2UNeGvUnrgVNGt1yg/viewform',
    chatAILink: '/chatbv/chat',
    flagCommentFormLink:
      'https://docs.google.com/forms/d/1PPDNxgUq4pxszCDZLYkcSI2RN4qhetMuG4nMlkk5_-k/edit',
  },
  featureFlags: {
    hasCriminalEnabled: true,
    hasSmartInsightsAutoLoadEnabled: true,
    propertyReportFlags: ['include_ca_data'],
    enableListExport: false,
    familyTreeEnabled: true,
    personReportSummaryEnabled: false,
    obituaryParserEnabled: true,
    familySearchEnabled: true,
    hasConsolidatedSearch: true,
    smartPersonSearchEnabled: true,
    hasReportPreferencesEnabled: true,
    hasMobileSearchHeaderRedesignEnabled: true,
    hasNewMobileHeaderDesignEnabled: true,
    hasShortChatCallout: true,
    shouldOpenNeighborhoodReport: true,
    hasChatBVEnabled: true,
    streamlinedPersonSearchEnabled: true,
    standardHeaderDesignEnabled: true,
    hasReportAttachmentsEnabled: true,
  },
  dataCollections: {
    SSDIRequestEnabled: true,
    census1940Enabled: true,
    // Structured collections that support the new GDT structured format
    structuredCollections: [
      {
        id: '0000011',
        plainName: 'New York Death Index, 1957-1972',
        type: 'death_index',
        ga4ReportType: 'ny_death_index',
        state: 'NY',
        yearStart: 1957,
        yearEnd: 1972,
      },
      {
        id: '0000004',
        plainName: 'California Death Index, 1940-1997',
        type: 'death_index',
        ga4ReportType: 'ca_death_index',
        state: 'CA',
        yearStart: 1940,
        yearEnd: 1997,
      },
      {
        id: '0000065',
        plainName: 'Tennessee Death Index, 1949-2014',
        type: 'death_index',
        ga4ReportType: 'tn_death_index',
        state: 'TN',
        yearStart: 1949,
        yearEnd: 2014,
      },
      {
        id: '0000030',
        plainName: 'Nebraska Birth Index, 1912-1989',
        type: 'birth_index',
        ga4ReportType: 'ne_birth_index',
        state: 'NE',
        yearStart: 1912,
        yearEnd: 1989,
      },
      {
        id: '0000033',
        plainName: 'Nebraska Marriage Index, 1956-2019',
        type: 'marriage_index',
        ga4ReportType: 'ne_marriage_index',
        state: 'NE',
        yearStart: 1956,
        yearEnd: 2019,
      },
      {
        id: '0000034',
        plainName: 'Nebraska Death Index, 1969-2019',
        type: 'death_index',
        ga4ReportType: 'ne_death_index',
        state: 'NE',
        yearStart: 1969,
        yearEnd: 2019,
      },
      {
        id: '0000064',
        plainName: 'Minnesota Death Index, 1904-2001',
        type: 'death_index',
        ga4ReportType: 'mn_death_index',
        state: 'MN',
        yearStart: 1904,
        yearEnd: 2001,
      },
      {
        id: '0000066',
        plainName: 'Texas Death Index, 1965-1998',
        type: 'death_index',
        ga4ReportType: 'tx_death_index',
        state: 'TX',
        yearStart: 1965,
        yearEnd: 1998,
      },
      {
        id: '0000138',
        plainName: 'Vermont Death Index, 1909-2024',
        type: 'death_index',
        ga4ReportType: 'vt_death_index',
        state: 'VT',
        yearStart: 1909,
        yearEnd: 2024,
      },
      {
        id: '0000052',
        plainName: 'Connecticut Birth Index, 1897-1917',
        type: 'birth_index',
        ga4ReportType: 'ct_birth_index',
        state: 'CT',
        yearStart: 1897,
        yearEnd: 1917,
      },
      {
        id: '0000036',
        plainName: 'Kentucky Birth Index, 1911-1989',
        type: 'birth_index',
        ga4ReportType: 'ky_birth_index',
        state: 'KY',
        yearStart: 1911,
        yearEnd: 1989,
      },
      {
        id: '0000069',
        plainName: 'Texas Birth Index, 1926-1948',
        type: 'birth_index',
        ga4ReportType: 'tx_birth_index',
        state: 'TX',
        yearStart: 1926,
        yearEnd: 1948,
      },
      {
        id: '0000082',
        plainName: 'Minnesota Birth Index, 1900-1934',
        type: 'birth_index',
        ga4ReportType: 'mn_birth_index',
        state: 'MN',
        yearStart: 1900,
        yearEnd: 1934,
      },
      {
        id: '0000038',
        plainName: 'Kentucky Marriage Index, 1973-1999',
        type: 'marriage_index',
        ga4ReportType: 'ky_marriage_index',
        state: 'KY',
        yearStart: 1973,
        yearEnd: 1999,
      },
      {
        id: '0000068',
        plainName: 'Tennessee Marriage Index, 1980-2014',
        type: 'marriage_index',
        ga4ReportType: 'tn_marriage_index',
        state: 'TN',
        yearStart: 1980,
        yearEnd: 2014,
      },
      {
        id: '0000170',
        plainName: 'Indiana Marriage Index, 1958-2022',
        type: 'marriage_index',
        ga4ReportType: 'in_marriage_index',
        state: 'IN',
        yearStart: 1958,
        yearEnd: 2022,
      },
      {
        id: '0000147',
        plainName: 'Minnesota Marriage Index, 1850-2022',
        type: 'marriage_index',
        ga4ReportType: 'mn_marriage_index',
        state: 'MN',
        yearStart: 1850,
        yearEnd: 2022,
      },
      {
        id: '0000067',
        plainName: 'Texas Death Index, 1999-2022',
        type: 'death_index',
        ga4ReportType: 'tx_death_index_1999_2022',
        state: 'TX',
        yearStart: 1999,
        yearEnd: 2022,
      },
      {
        id: '0000128',
        plainName: 'Maine Death Index, 1956-2009',
        type: 'death_index',
        ga4ReportType: 'me_death_index',
        state: 'ME',
        yearStart: 1956,
        yearEnd: 2009,
      },
      {
        id: '0000140',
        plainName: 'Louisiana Death Index, 1819-1973',
        type: 'death_index',
        ga4ReportType: 'la_death_index',
        state: 'LA',
        yearStart: 1819,
        yearEnd: 1973,
      },
      {
        id: '0000162',
        plainName: 'Arkansas Death Index, 1935-1961',
        type: 'death_index',
        ga4ReportType: 'ar_death_index',
        state: 'AR',
        yearStart: 1935,
        yearEnd: 1961,
      },
      {
        id: '0000029',
        plainName: 'Kentucky Death Index, 1911-1989',
        type: 'death_index',
        ga4ReportType: 'ky_death_index',
        state: 'KY',
        yearStart: 1911,
        yearEnd: 1989,
      },
    ],
  },
  data: {
    brandName: 'BeenVerified',
    brandAbbreviation: 'bv' as 'bv',
    brandSupportEmail: 'support@beenverified.com',
    legalName: 'BeenVerified, LLC',
    supportPhone: '1-844-823-2869',
    customerSupportPhone: '1-888-579-5910',
    supportEmail: 'support@beenverified.com',
    complianceEmail: 'compliance@beenverified.com',
    pdfPrice: '$4.95',
    rewardsDisclaimer:
      'Certain products and services, including vehicle purchase/sale opportunities, provided above include offers from third parties and/or external partners from whom we may receive limited compensation. Please be advised that these offers are provided as a convenience and are a sample, but do not necessarily include ALL offers, products or services available in the marketplace.',
    carGeniusPhone: '1-877-418-2717',
    upgradePlanCustomSolutionHeading: 'Need more reports or users?',
    upgradePlanCustomSolutionDescription: 'Let’s talk',
    limitReachedSubHeading:
      'We offer different solutions to match your search needs',
    contactOptionsCustomPlanDisplay: 'Request larger plan',
    premiumModalCardData: [
      {
        title: 'Person Search',
        icon: premiumModalPersonIcon,
        content:
          'Dive deeper with possible contact information, criminal & address history, etc.',
      },
      {
        title: 'Phone Search',
        icon: premiumModalPhoneIcon,
        content: 'See who might be behind the numbers',
      },
      {
        title: 'Property Search',
        icon: premiumModalPropertyIcon,
        content: 'Discover more about addresses & neighborhoods',
      },
    ],
    premiumModalContent:
      "Looks like you're missing out on key searches, like person search. Unlock premium data for access to person, phone, email, property, dark web, unclaimed money searches and more!",
    validReportCountThreshold: 5,
    plansWithout5ReportBlocker: [
      'Referral_User_0_1_month_freemium_limit3',
      '7_day_trial_1_00_up_front_28_79_recurring_monthly_freshness_limit_100_vin_no_pdf_vehicle_only',
      '7_day_trial_5_00_up_front_28_79_recurring_monthly_freshness_limit_100_vin_free_pdf_vehicle_only',
    ],
    blockUpgradeWindowThreshold: 24,
    smartSearchV1FeedbackLink: 'https://forms.gle/dxxWWFPH326CtnEm8',
    copyrightText:
      '© 2024 BeenVerified, LLC. All rights reserved. BeenVerified® and the BeenVerified star mascot are registered trademarks of BeenVerified, LLC',
    defaultSearchFormEventName: 'openPersonSearch',
    brandCustomerSupportSchedule: {
      days: 'Monday - Friday',
      hours: '9am - 6pm EST',
    },
    customerSupportAvailabilityHours: {
      email: 'Available 24 hours a day',
      chat: 'Chat available 24 hours a day via our AI assistant',
    },
    peopleSubSearches: ['person', 'contact', 'ancestry', 'obituary'],
    nameHistorySeeMoreFlag: true,
  },
  config: {
    socialMedia: [
      {
        textContent: 'X',
        alternateTextContent: '@BeenVerified',
        href: 'https://x.com/BeenVerified',
        imgLogoUrl: twitterLogo,
        icon: <X fontSize="small" sx={{ color: '#0052FF' }} />,
        hideOnSide: false,
        hideinNeedAssistanceNewDesign: false,
      },
      {
        textContent: 'Facebook',
        alternateTextContent: 'facebook.com/Beenverified',
        href: 'https://www.facebook.com/BeenVerified',
        imgLogoUrl: facebookLogo,
        icon: <FacebookRounded fontSize="small" sx={{ color: '#0052FF' }} />,
        hideOnSide: false,
        hideinNeedAssistanceNewDesign: false,
      },
      {
        textContent: 'Instagram',
        alternateTextContent: 'instagram.com/BeenVerified',
        href: 'https://www.instagram.com/beenverified/',
        imgLogoUrl: instagramLogo,
        icon: <Instagram fontSize="small" sx={{ color: '#0052FF' }} />,
        hideOnSide: true,
        hideinNeedAssistanceNewDesign: false,
      },
      {
        textContent: 'Linkedin',
        alternateTextContent: 'linkedin.com/company/beenverified-com',
        href: 'https://www.linkedin.com/company/beenverified-com',
        imgLogoUrl: linkedinLogo,
        icon: <LinkedIn fontSize="small" sx={{ color: '#0052FF' }} />,
        hideOnSide: true,
        hideinNeedAssistanceNewDesign: false,
      },
      {
        textContent: 'Pinterest',
        href: 'https://www.pinterest.com/beenverified/',
        imgLogoUrl: pinterestLogo,
        icon: <Pinterest fontSize="small" sx={{ color: '#0052FF' }} />,
        hideOnSide: true,
        hideinNeedAssistanceNewDesign: false,
      },
      {
        textContent: 'Beenverified Blog',
        href: 'https://www.beenverified.com/blog/',
        imgLogoUrl: beenverifiedLogo,
        icon: <BVLogo fontSize="medium" color="primary" />,
        hideOnSide: true,
        hideinNeedAssistanceNewDesign: true,
      },
    ],
    searchTabsIndexRecords: [
      {
        displayName: 'Person',
        id: 'peopleTab',
        icon: <Person fontSize="small" />,
        class: 'noBorderBottom noBorderRight',
        isLocked: true,
        isHidden: true,
        internalTabs: [
          {
            label: 'Search By Name',
            mobileLabel: 'Name',
            libFormComponentName: 'SearchPersonForm',
            eventCategory: 'People Search',
          },
          {
            label: 'Search By Address',
            mobileLabel: 'Address',
            libFormComponentName: 'SearchPersonByAddressForm',
            eventCategory: 'Person search by address',
          },
          {
            label: 'Search By Job Title',
            mobileLabel: 'Job Title',
            libFormComponentName: 'SearchContactForm',
            customTrackEvent: {
              category: 'contact search',
              action: 'navigation click',
              label: 'search',
            },
          },
        ],
      },
      {
        displayName: 'Ancestor',
        id: 'ancestorTab',
        icon: <Groups fontSize="small" />,
        class: 'noBorderBottom',
        isLocked: false,
        isHidden: false,
        internalTabs: [
          {
            label: 'Search By Ancestor',
            mobileLabel: 'Ancestor',
            libFormComponentName: 'AncestorSearchForm',
            eventCategory: 'Ancestor Search',
          },
        ],
      },
      {
        displayName: 'Obituary',
        id: 'obituaryTab',
        icon: <LocalFlorist fontSize="small" />,
        class: 'noBorderBottom',
        isLocked: false,
        isHidden: false,
        internalTabs: [
          {
            label: 'Search By Obituary',
            mobileLabel: 'Obituary',
            libFormComponentName: 'ObituarySearchForm',
            eventCategory: 'Obituary Search',
          },
        ],
      },
      {
        displayName: 'Vital Records',
        id: 'vitalRecordsTab',
        icon: <Favorite fontSize="small" />,
        class: 'noBorderBottom',
        isLocked: false,
        isHidden: false,
        internalTabs: [
          {
            label: 'Search Vital Records',
            mobileLabel: 'Vital Records',
            libFormComponentName: 'AdvancedSearchForm',
            eventCategory: 'Vital Records Search',
          },
        ],
      },
      {
        displayName: 'Census',
        id: 'censusTab',
        icon: <LocationCity fontSize="small" />,
        class: 'noBorderBottom',
        isLocked: false,
        isHidden: false,
        internalTabs: [
          {
            label: 'Search Census',
            mobileLabel: 'Census',
            libFormComponentName: 'CensusSearchForm',
            eventCategory: 'Census Search',
          },
        ],
      },
    ],
    searchTabs: [
      {
        displayName: 'People',
        id: 'peopleTab',
        icon: (
          <Person
            fontSize="small"
            sx={{ color: { xs: '#0052FF', md: '#0A0B0D' } }}
          />
        ),
        class: 'noBorderBottom noBorderRight',
        isLocked: true,
        isHidden: true,
        internalTabs: [
          {
            label: 'Search By Name',
            mobileLabel: 'Name',
            libFormComponentName: 'SearchPersonForm',
            eventCategory: 'People Search',
          },
          {
            label: 'Search By Address',
            mobileLabel: 'Address',
            libFormComponentName: 'SearchPersonByAddressForm',
            eventCategory: 'Person search by address',
          },
          {
            label: 'Search By Job Title',
            mobileLabel: 'Job Title',
            libFormComponentName: 'SearchContactForm',
            customTrackEvent: {
              category: 'contact search',
              action: 'navigation click',
              label: 'search',
            },
          },
        ],
      },
      {
        displayName: 'Phone',
        id: 'phoneTab',
        icon: (
          <Phone
            fontSize="small"
            sx={{ color: { xs: '#0052FF', md: '#0A0B0D' } }}
          />
        ),
        class: 'noBorderBottom noBorderRight',
        isLocked: true,
        isHidden: true,
        internalTabs: [
          {
            label: 'Search By Phone Number',
            mobileLabel: 'Phone Number',
            libFormComponentName: 'SearchPhoneForm',
            eventCategory: 'Phone Search',
          },
        ],
      },
      {
        displayName: 'Property',
        id: 'propertyTab',
        icon: (
          <Home
            fontSize="small"
            sx={{ color: { xs: '#0052FF', md: '#0A0B0D' } }}
          />
        ),
        class: 'noBorderBottom',
        isLocked: true,
        isHidden: true,
        internalTabs: [
          {
            label: 'Address Report',
            mobileLabel: 'Report',
            libFormComponentName: 'SearchPropertyForm',
            eventCategory: 'property',
          },
          {
            label: 'Pre-foreclosure',
            mobileLabel: 'Pre-foreclosure',
            libFormComponentName: 'SearchPFCPropertiesForm',
            eventCategory: 'Pre-Foreclosure',
          },
        ],
      },
      {
        displayName: 'Email',
        id: 'emailTab',
        icon: (
          <Email
            fontSize="small"
            sx={{ color: { xs: '#0052FF', md: '#0A0B0D' } }}
          />
        ),
        class: 'noBorderRight',
        isLocked: true,
        isHidden: true,
        internalTabs: [
          {
            label: 'Search By Email',
            mobileLabel: 'Email',
            libFormComponentName: 'SearchEmailForm',
            eventCategory: 'Email Search',
          },
        ],
      },
      {
        displayName: 'Username',
        id: 'usernameTab',
        icon: (
          <AlternateEmail
            fontSize="small"
            sx={{ color: { xs: '#0052FF', md: '#0A0B0D' } }}
          />
        ),
        class: 'noBorderRight',
        isLocked: true,
        isHidden: true,
        internalTabs: [
          {
            label: 'Search By Username',
            mobileLabel: 'Username',
            libFormComponentName: 'SearchUsernameForm',
            eventCategory: 'Username Search',
          },
        ],
      },
      {
        displayName: 'Vehicle',
        id: 'vehicleTab',
        icon: (
          <DirectionsCar
            fontSize="small"
            sx={{ color: { xs: '#0052FF', md: '#0A0B0D' } }}
          />
        ),
        internalTabs: [
          {
            label: 'VIN',
            mobileLabel: 'VIN',
            libFormComponentName: 'VINSearchForm',
          },
          {
            label: 'License Plate',
            mobileLabel: 'License Plate',
            libFormComponentName: 'LicensePlateSearchForm',
          },
          {
            label: 'Year, Make, Model',
            mobileLabel: 'Year, Make, Model',
            libFormComponentName: 'YMMSearchForm',
          },
        ],
      },
    ],
    sideMenuItems: [
      {
        route: '/dashboard',
        icon: <Home sx={{ color: '#0052FF' }} />,
        text: 'My Dashboard',
        name: 'dashboard',
        state: '',
        'data-cy': 'dashboard',
        ga4EventType: 'dashboard',
      },
      {
        route: '/dashboard/reports',
        icon: <Restore sx={{ color: '#0052FF' }} />,
        text: 'Recent Reports',
        name: 'recentReports',
        state: '',
        'data-cy': 'recent_reports',
        ga4EventType: 'recent_reports',
      },
      {
        route: '/dashboard/lists',
        icon: <List sx={{ color: '#0052FF' }} />,
        text: 'Saved Reports and Lists',
        state: '',
        name: 'lists',
        'data-cy': 'saved_reports_and_list',
        ga4EventType: 'lists',
      },
      {
        route: '/dashboard/fraud',
        icon: <Radar sx={{ color: '#0052FF' }} />,
        text: (
          <Stack
            flexDirection="row"
            alignItems="center"
            justifyContent="space-between"
          >
            FraudScan
            <PillList items={[{ label: 'New' }]} />
          </Stack>
        ),
        state: '',
        name: 'fraudScan',
        ga4EventType: 'fraud_scan',
      },
      {
        route: '/dashboard/personality-traits',
        icon: <Psychology sx={{ color: '#0052FF' }} />,
        text: (
          <Stack
            flexDirection="row"
            alignItems="center"
            justifyContent="space-between"
          >
            Personality Traits
            <PillList items={[{ label: 'New' }]} />
          </Stack>
        ),
        state: '',
        name: 'personalityTraits',
        'data-cy': 'personality_traits',
        ga4EventType: 'personality_traits',
      },
      {
        route: '/dashboard/astrology',
        icon: <FlareRounded sx={{ color: '#0052FF' }} />,
        text: (
          <Stack
            flexDirection="row"
            alignItems="center"
            justifyContent="space-between"
          >
            Astrology
            <PillList items={[{ label: 'New' }]} />
          </Stack>
        ),
        state: '',
        name: 'astrology',
        ga4EventType: 'astrology',
      },
      {
        route: '/dashboard/family-ancestry',
        icon: <CustomIcons.FamilyTreeAncestryIcon sx={{ color: '#0052FF' }} />,
        text: 'Family & Ancestry',
        state: '',
        name: 'family&ancestry',
        ga4EventType: 'family_ancestry',
        childItems: [
          {
            route: '/family-tree',
            icon: <CustomIcons.FamilyTreeIcon sx={{ color: '#0052FF' }} />,
            text: 'Family Tree',
            state: '',
            name: 'familyTree',
            ga4EventType: 'family_tree',
          },
          {
            route: '/dashboard/family-insights',
            icon: <PieChartOutline sx={{ color: '#0052FF' }} />,
            text: 'Family Insights',
            state: '',
            name: 'familyInsights',
            ga4EventType: 'family_insights',
          },
          {
            route: '/dashboard/obituary',
            icon: <LocalFlorist sx={{ color: '#0052FF' }} />,
            text: 'Obituary Search',
            state: '',
            name: 'obituarySearch',
            isLocked: true,
            ga4EventType: 'obituary',
          },
          {
            route: '/dashboard/name-history',
            icon: <LocalLibraryRounded />,
            text: 'Name History',
            state: '',
            name: 'nameHistory',
            ga4EventType: 'name_history',
          },
        ],
      },
      {
        route: '/dashboard/rewards',
        icon: <Redeem sx={{ color: '#0052FF' }} />,
        text: 'Member Perks',
        state: '',
        name: 'memberPerks',
        ga4EventType: 'member_perks',
      },
      {
        route: '/dashboard/monitoring',
        icon: <NotificationsNone sx={{ color: '#0052FF' }} />,
        text: 'Monitoring',
        state: '',
        name: 'monitoring',
        ga4EventType: 'monitoring',
      },
      {
        route: '/search/owner',
        icon: <PersonPinCircle sx={{ color: '#0052FF' }} />,
        text: 'Owner Search',
        state: '',
        name: 'owner_search',
        ga4EventType: 'owner_search',
      },
      {
        route: '/dashboard/my-garage',
        icon: <DirectionsCarRounded sx={{ color: '#0052FF' }} />,
        text: 'My Garage',
        state: '',
        name: 'myGarage',
        ga4EventType: 'my_garage',
      },
      {
        route: '/dashboard/id-monitor',
        icon: (
          <img
            src={IdMonitorBvLogo}
            style={{ height: '27px', marginRight: '8px' }}
          />
        ),
        text: 'ID Monitor',
        state: '',
        name: 'idMonitor',
        isLocked: false,
        ga4EventType: 'id_monitor',
        childItems: [
          {
            route: '/dashboard/dark-web',
            icon: <CustomIcons.DarkWebIcon color="primary" />,
            text: 'Dark Web',
            state: '',
            name: 'darkWebScan',
            'data-cy': 'dark_web_scan',
            isLocked: false,
            ga4EventType: 'dark_web',
          },
          {
            route: '/dashboard/unclaimed-money',
            icon: <AttachMoney sx={{ color: '#0052FF' }} />,
            text: 'Unclaimed Money',
            state: '',
            name: 'unclaimedMoney',
            'data-cy': 'unclaimed_money',
            isLocked: false,
            ga4EventType: 'unclaimed_money',
          },
        ],
      },

      {
        route: '/dashboard/neighborhood-report',
        icon: <MapRounded sx={{ color: '#0052FF' }} />,
        text: 'Neighborhood Report',
        state: '',
        name: 'neighborhoodReport',
        isLocked: true,
        ga4EventType: 'neighborhood_report',
      },
      {
        route: '/search/contact?advancedSearch=true&source=contactSearch',
        icon: <Work sx={{ color: '#0052FF' }} />,
        text: 'Contact Pro',
        state: '',
        name: 'contactSearch',
        isLocked: false,
        ga4EventType: 'contact_search',
      },
      {
        route: '/dashboard/billing',
        icon: <AccountCircle sx={{ color: '#0052FF' }} />,
        text: 'My Account',
        state: '',
        name: 'myAccount',
        'data-cy': 'my_account',
        ga4EventType: 'my_account',
      },

      {
        route: '/dashboard/referrals',
        icon: <PersonAdd sx={{ color: '#0052FF' }} />,
        text: 'Send Invite',
        state: '',
        name: 'referrals',
        ga4EventType: 'referrals',
      },
    ],
    reportTypeFilterOptions,
    higherConfidenceThreshold: 50,
    hardcodedPlans: [],
    useLLMPersonMaxRetries: 2,
  },
  keys: {
    rapidsAPIKey: '7ZfcCjTZKz4rRGUm6ny6',
    mapboxKey:
      'pk.eyJ1IjoiYmVlbnZlcmlmaWVkIiwiYSI6ImNqeXN3ejY2MDAwbXczaHFzcnp6cmo5eGUifQ.hEfUf5T6xAzgW8wghHulEA',
    mrRogersAPIKey: 'kl6x16zhIp39hszFhGt5cxAfDV1MoXId',
    streetViewStaticApiKey: 'AIzaSyB1wzcy6dXy1xh3eZ8QfjClmeVCEyaSLIo',
    topHapApiKey: 'si_MKritZu1BytMaH',
    astrologyUser: import.meta.env.VITE_ASTROLOGY_API_USER,
    astrologyKey: import.meta.env.VITE_ASTROLOGY_API_KEY,
  },
  variationPlanNames: [
    '7_day_trial_1_00_up_front_28_79_recurring_monthly_freshness_limit_100_vin_no_pdf_vehicle_only',
    '7_day_trial_5_00_up_front_28_79_recurring_monthly_freshness_limit_100_vin_free_pdf_vehicle_only',
  ],
  paymentPremiumModalCardData: {
    premiumPlan:
      '36_79_1_month_nofree_afill_limit_100_freepdf_upsell_alldataaccess',
    premiumPlanAmount: '$36.79',
    premiumPlanReports: [
      'Person Reports',
      'Property Reports',
      'Username, Phone & Email Reports',
      'Dark Web Scan',
    ],
    currentPlanReports: [
      'VIN & License Plate Lookup',
      'Year, Make, Model Search',
    ],
    premiumMessage:
      'to unlock additional search options of names, phones, addresses & more!',
  },
  downsellModalCardData: {
    downsellPlan: '14_99_1_month_nofree_afill_limit25reports_freepdf_downsell',
    downsellPlanAmount: '14.99',
  },
  internationalPlanNames: {
    vinPlan: [
      // BV Vehicle international plans
      '7_day_trial_1_00_up_front_22_99_recurring_monthly_limit_50_no_pdf_vehicle_international',
      '7_day_trial_5_00_up_front_22_99_recurring_monthly_limit_free_pdf_vehicle_international',
      '22_99_1_month_limit_50_freepdf_vehicle_international',
      '44_83_3_month_limit_50_freepdf_vehicle_international',
      'one_check_29_99_60day_renewal_limit_1_bv_international',
      // BV Vehicle international reactivation plans
      '22_99_1_month_limit_50_freepdf_vehicle_international_reactivation',
      '44_83_3_month_limit_50_freepdf_vehicle_international_reactivation',
    ],

    languagePlan: [
      // BV Language international plans
      '7_day_trial_1_00_up_front_9_99_recurring_monthly_limit_0_no_pdf_language_international',
      '9_99_1_month_limit_0_nopdf_language_international',
      '19_47_3_month_limit_0_nopdf_language_international',
      // BV Language international reactivation plans
      '9_99_1_month_limit_0_nopdf_language_international_reactivation',
      '19_47_3_month_limit_0_nopdf_language_international_reactivation',
    ],
  },
  migrationPlanNames: [
    '9_95_1_month_nofree_afill_limit100reports_freepdf_plan_migration',
    '22_86_1_month_nofree_afill_limit100reports_freepdf_plan_migration_v3',
  ],
  phoneOnlyPlanNames: [
    // signups
    '7_day_trial_1_00_up_front_24_99_recurring_monthly_freshness_limit_100_no_pdf_phone_international',
    '7_day_trial_5_00_up_front_24_99_recurring_monthly_freshness_limit_100_free_pdf_phone_international',
    // upgrades
    '49_99_1_month_nofree_afill_limit_200_freepdf_international_phoneonly_upsell',
    '89_99_1_month_nofree_afill_limit_400_freepdf_international_phoneonly_upsell',
    '174_99_1_month_nofree_afill_limit_1000_freepdf_international_phoneonly_upsell',
    '299_99_1_month_nofree_afill_limit_2500_freepdf_international_phoneonly_upsell',
    // reactivations
    '24_99_1_month_nofree_afill_limit_100_freepdf_international_phoneonly_reactivation',
    '49_99_1_month_nofree_afill_freshness_limit_200_freepdf_international_phoneonly_reactivation',
    '89_99_1_month_nofree_afill_freshness_limit_400_freepdf_international_phoneonly_reactivation',
    '174_99_1_month_nofree_afill_freshness_limit_1000_freepdf_international_phoneonly_reactivation',
    '299_99_1_month_nofree_afill_freshness_limit_2500_freepdf_international_phoneonly_reactivation',
  ],
  spanishTranslationPlanNames: [
    '7_day_trial_1_00_up_front_24_99_recurring_monthly_freshness_limit_100_no_pdf_phone_international_phone_only_spanish',
    '7_day_trial_1_00_up_front_32_89_recurring_monthly_freshness_limit_100_no_pdf_phone_spanish',
    '7_day_trial_1_00_up_front_27_99_recurring_monthly_limit_100_no_pdf_vehicle_international_spanish',
    '7_day_trial_1_00_up_front_32_89_recurring_monthly_freshness_limit_100_vin_no_pdf_spanish',
    '7_day_trial_5_00_up_front_24_99_recurring_monthly_freshness_limit_100_free_pdf_phone_international_phone_only_spanish',
    '7_day_trial_5_00_up_front_32_89_recurring_monthly_freshness_limit_100_free_pdf_phone_spanish',
    '7_day_trial_5_00_up_front_27_99_recurring_monthly_limit_100_free_pdf_vehicle_international_spanish',
    '7_day_trial_5_00_up_front_32_89_recurring_monthly_freshness_limit_100_vin_free_pdf_spanish',
    '5_00_1_month_nofree_afill_freshness_limit_20_freepdf_international_spanish',
    '5_00_1_month_nofree_afill_freshness_limit_20_freepdf_spanish',
    '5_00_1_month_nofree_afill_freshness_limit_20_freepdf_international_vehicle_only_spanish',
    'one_check_29_99_60day_renewal_limit_1_bv_international_vehicle_only_spanish',
    'one_check_29_99_60day_renewal_limit_1_bv_vehicle_spanish',
  ],
  personalityTraitsColors: {
    radioButtonColors: ['#DC0015', '#EA6672', '#808080', '#90d393', '#388E3C'],
    radioButtonHoverColors: [
      '#f9d0d3',
      '#fbdfe1',
      '#d8d8d8',
      '#e4f4e5',
      '#bae4bc',
    ],
  },
  internationalPhoneInput: {
    enabled: true,
    utilsUrl: 'https://cdnx.beenverified.com/assets/js/utils.js',
    phoneSearchCountryCodes: internationalPhoneSearchLocale.countryCodes,
    phoneSearchPlaceholders: internationalPhoneSearchLocale.placeholders,
    phoneFraudSearchCountryCodes:
      internationalPhoneFraudSearchLocale.countryCodes,
    phoneFraudSearchPlaceholders:
      internationalPhoneFraudSearchLocale.placeholders,
  },
};

export const sideMenuItemsForNewDesign = (
  isInAstrologyStandaloneVariation: boolean,
  isInCourtCasesVariation: boolean
) => {
  const recentReportsItem: SideMenuItem = {
    route: '/dashboard/reports',
    icon: <Restore sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Recent Reports',
    name: 'recentReports',
    state: '',
    'data-cy': 'recent_reports',
  };

  const savedReportsItem: SideMenuItem = {
    route: '/dashboard/lists',
    icon: <List sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Saved Reports and Lists',
    state: '',
    name: 'lists',
    'data-cy': 'saved_reports_and_list',
  };

  const myGarageItem: SideMenuItem = {
    route: '/dashboard/my-garage',
    icon: <DirectionsCarRounded sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'My Garage',
    state: '',
    name: 'myGarage',
  };

  const contactProItem: SideMenuItem = {
    route: '/search/contact?advancedSearch=true&source=contactSearch',
    icon: <Work sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Contact Pro',
    state: '',
    name: 'contactSearch',
    isLocked: false,
  };

  const emailSearchItem: SideMenuItem = {
    route: '/dashboard/email-search',
    icon: (
      <CustomIcons.AttachEmailOutlined
        color="primary"
        sx={{ fontSize: '24px' }}
      />
    ),
    text: 'Email Search',
    state: '',
    name: 'emailSearch',
  };

  const unclaimedMoneyItem: SideMenuItem = {
    route: '/dashboard/unclaimed-money',
    icon: <AttachMoney sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Unclaimed Money',
    state: '',
    name: 'unclaimedMoney',
    'data-cy': 'unclaimed_money',
    isLocked: false,
  };

  const courtCasesItem: SideMenuItem = {
    route: '/dashboard/court-cases/cases',
    icon: <Gavel sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: (
      <Stack
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
      >
        Court Cases
        <PillList items={[{ label: 'New' }]} />
      </Stack>
    ),
    state: '',
    name: 'courtCases',
  };

  const fraudScanItem: SideMenuItem = {
    route: '/dashboard/fraud',
    icon: <Radar sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: (
      <Stack
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
      >
        FraudScan
        <PillList items={[{ label: 'New' }]} />
      </Stack>
    ),
    state: '',
    name: 'fraudScan',
  };

  const neighborhoodSearchItem: SideMenuItem = {
    route: '/dashboard/neighborhood-report',
    icon: <MapRounded sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Neighborhood Search',
    state: '',
    name: 'neighborhoodSearch',
    isLocked: false,
  };

  const crimeIncidentSearchItem: SideMenuItem = {
    route: '/dashboard/neighborhood-report',
    icon: <CustomIcons.HandCuff sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Crime Incidents',
    state: '',
    name: 'crimeIncidents',
  };

  const personalityTraitsItem: SideMenuItem = {
    route: '/dashboard/personality-traits',
    icon: <Psychology sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: (
      <Stack
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        fontSize="1.125rem"
      >
        Personality Traits
        <PillList items={[{ label: 'New' }]} />
      </Stack>
    ),
    state: '',
    name: 'personalityTraits',
    'data-cy': 'personality_traits',
  };

  const astrologyItem: SideMenuItem = {
    route: '/dashboard/astrology',
    icon: <FlareRounded color="primary" />,
    text: (
      <Stack
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        fontSize="1.125rem"
      >
        Astrology
        <PillList items={[{ label: 'New' }]} />
      </Stack>
    ),
    state: '',
    name: 'astrology',
    'data-cy': 'astrology',
  };

  const familyDashboardItem: SideMenuItem = {
    route: '/dashboard/family-ancestry',
    icon: (
      <CustomIcons.FamilyTreeAncestryIcon
        color="primary"
        sx={{ fontSize: '24px' }}
      />
    ),
    text: 'Family Dashboard',
    state: '',
    name: 'family-dashboard',
  };

  const familyTreeItem: SideMenuItem = {
    route: '/family-tree',
    icon: (
      <CustomIcons.FamilyTreeIcon color="primary" sx={{ fontSize: '24px' }} />
    ),
    text: 'Family Tree',
    state: '',
    name: 'familyTree',
  };

  const familyMapItem: SideMenuItem = {
    route: '/family-map',
    icon: <MapRounded sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Family Map',
    state: '',
    name: 'familyMap',
  };

  const familyInsightsItem: SideMenuItem = {
    route: '/dashboard/family-insights',
    icon: <PieChartOutline sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Family Insights',
    state: '',
    name: 'familyInsights',
  };

  const obituarySearchItem: SideMenuItem = {
    route: '/dashboard/obituary',
    icon: <LocalFlorist sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Obituary Search',
    state: '',
    name: 'obituarySearch',
  };

  const nameHistoryItem: SideMenuItem = {
    route: '/dashboard/name-history',
    icon: <LocalLibraryRounded sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Name History',
    state: '',
    name: 'nameHistory',
  };

  const idMonitorItem: SideMenuItem = {
    route: '/dashboard/id-monitor',
    icon: (
      <CustomIcons.IdMonitorIcon color="primary" sx={{ fontSize: '24px' }} />
    ),
    text: 'ID Monitor',
    state: '',
    name: 'idMonitor',
    isLocked: false,
  };

  const darkWebItem: SideMenuItem = {
    route: '/dashboard/dark-web',
    icon: <CustomIcons.DarkWebIcon color="primary" sx={{ fontSize: '24px' }} />,
    text: 'Dark Web',
    state: '',
    name: 'darkWebScan',
    'data-cy': 'dark_web_scan',
    isLocked: false,
  };

  const myAccountItem: SideMenuItem = {
    route: '/dashboard/billing',
    icon: <AccountCircle sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'My Account',
    state: '',
    name: 'myAccount',
    'data-cy': 'my_account',
  };

  const memberPerksItem: SideMenuItem = {
    route: '/dashboard/rewards',
    icon: <Redeem sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Member Perks',
    state: '',
    name: 'memberPerks',
  };

  const sendInviteItem: SideMenuItem = {
    route: '/dashboard/referrals',
    icon: <PersonAdd sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Send Invite',
    state: '',
    name: 'referrals',
  };

  const dashboardItem: SideMenuItem = {
    route: '/dashboard',
    icon: <Home sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'My Dashboard',
    name: 'dashboard',
    state: '',
    'data-cy': 'dashboard',
  };

  const reportsItem: SideMenuItem = {
    route: '',
    icon: <Summarize sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Reports',
    name: 'reports',
    state: '',
    'data-cy': 'reports',
    childItems: [recentReportsItem, savedReportsItem, myGarageItem],
  };

  const chatBVItem: SideMenuItem = {
    route: '/chatbv/chat',
    icon: <AutoAwesomeRounded sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: (
      <Stack
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
      >
        Deep Search
        <PillList items={[{ label: 'New' }]} />
      </Stack>
    ),
    name: 'chat-ai',
    state: '',
  };

  const moreSearchesItem: SideMenuItem = {
    route: '',
    icon: <Search sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: (
      <Stack
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
      >
        More Searches
        <PillList items={[{ label: 'New' }]} />
      </Stack>
    ),
    state: '',
    name: 'more-searches',
    childItems: [
      chatBVItem,
      unclaimedMoneyItem,
      fraudScanItem,
      neighborhoodSearchItem,
      emailSearchItem,
      crimeIncidentSearchItem,
      contactProItem,
      ...(isInCourtCasesVariation ? [courtCasesItem] : []),
    ],
  };

  const familyAncestryItem: SideMenuItem = {
    route: '/dashboard/family-ancestry',
    icon: <FamilyRestroom sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Family & Ancestry',
    state: '',
    name: 'family&ancestry',
    childItems: [
      familyDashboardItem,
      familyInsightsItem,
      familyTreeItem,
      obituarySearchItem,
      nameHistoryItem,
    ],
  };

  const digitalFootprintItem: SideMenuItem = {
    route: '/dashboard/digital-footprint',
    icon: (
      <CustomIcons.DigitalFootprintIcon
        color="primary"
        sx={{ fontSize: '24px' }}
      />
    ),
    text: 'Digital Footprint',
    state: '',
    name: 'digitalfootprint',
  };

  const notificationsItem: SideMenuItem = {
    route: '/dashboard/notifications',
    icon: <Notifications sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Notifications',
    state: '',
    name: 'notifications',
  };

  const myProfileItem: SideMenuItem = {
    route: '',
    icon: <ManageAccounts sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'My Profile',
    state: '',
    name: 'my-profile',
    childItems: [myAccountItem, memberPerksItem, sendInviteItem],
  };

  const reportAttachmentsItem: SideMenuItem = {
    route: '/dashboard/report-attachments',
    icon: <CloudUpload sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Report Attachments',
    state: '',
    name: 'report-attachments',
  };

  const items: SideMenuItem[] = [
    dashboardItem,
    {
      ...reportsItem,
      childItems: [recentReportsItem, reportAttachmentsItem, savedReportsItem],
    },
    {
      ...moreSearchesItem,
      childItems: [
        chatBVItem,
        unclaimedMoneyItem,
        contactProItem,
        { ...darkWebItem, text: 'Dark Web Scan' },
        { ...myGarageItem, text: 'Vehicle Search' },
        neighborhoodSearchItem,
        emailSearchItem,
        crimeIncidentSearchItem,
        fraudScanItem,
        ...(isInCourtCasesVariation ? [courtCasesItem] : []),
      ],
    },
    {
      ...familyAncestryItem,
      text: 'Family & Ancestry',
      childItems: [
        familyDashboardItem,
        familyTreeItem,
        familyInsightsItem,
        familyMapItem,
        obituarySearchItem,
        nameHistoryItem,
      ],
    },
    {
      ...myProfileItem,
      text: 'My Account',
      childItems: [
        { ...myAccountItem, text: 'My Profile' },
        memberPerksItem,
        notificationsItem,
        digitalFootprintItem,
        idMonitorItem,
        personalityTraitsItem,
        ...(isInAstrologyStandaloneVariation ? [astrologyItem] : []),
        sendInviteItem,
      ],
    },
  ];

  return items;
};

export const internationalSideMenuItems = [
  {
    route: '',
    icon: <Summarize sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Reports',
    name: 'reports',
    state: '',
    'data-cy': 'reports',
    childItems: [
      {
        route: '/dashboard/reports',
        icon: <Restore sx={{ fontSize: '24px', color: '#0052FF' }} />,
        text: 'Recent Reports',
        name: 'recentReports',
        state: '',
        'data-cy': 'recent_reports',
      },
      {
        route: '/dashboard/lists',
        icon: <List sx={{ fontSize: '24px', color: '#0052FF' }} />,
        text: 'Saved Reports and Lists',
        state: '',
        name: 'lists',
        'data-cy': 'saved_reports_and_list',
      },
      {
        route: '/dashboard/my-garage',
        icon: (
          <DirectionsCarRounded color="primary" sx={{ fontSize: '24px' }} />
        ),
        text: 'My Garage',
        state: '',
        name: 'myGarage',
      },
    ],
  },
  {
    route: '',
    icon: <Lightbulb sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Personal Growth',
    name: 'personal-growth',
    state: '',
    'data-cy': 'personal-growth',
  },
  {
    route: '',
    icon: <NotificationsActive sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'Monitoring Hub',
    state: '',
    name: 'monitoring-hub',
    childItems: [
      {
        route: '/dashboard/monitoring',
        icon: <NotificationsNone sx={{ fontSize: '24px', color: '#0052FF' }} />,
        text: 'Monitoring',
        state: '',
        name: 'monitoring',
      },
    ],
  },
  {
    route: '',
    icon: <ManageAccounts sx={{ fontSize: '24px', color: '#0052FF' }} />,
    text: 'My Profile',
    state: '',
    name: 'my-profile',
    childItems: [
      {
        route: '/dashboard/billing',
        icon: <AccountCircle sx={{ fontSize: '24px', color: '#0052FF' }} />,
        text: 'My Account',
        state: '',
        name: 'myAccount',
        'data-cy': 'my_account',
      },
    ],
  },
];
